import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcIndicator = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M15.874 22a4.01 4.01 0 0 0 0-2H22a1 1 0 1 1 0 2h-6.126Zm-7.748 0H2a1 1 0 1 1 0-2h6.126a4.007 4.007 0 0 0 0 2Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("circle", {
  cx: "12",
  cy: "21",
  fill: "var(--mds-nav-icon-medium)",
  r: "2"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M7 2a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h3l2 2 2-2h3a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H7Z",
  fill: "var(--mds-nav-icon-accent)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M12 5a1 1 0 0 0-1 1v2.5a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1Zm0 7.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  fill: "var(--mds-nav-border-strong)"
})), "IcIndicator");

export { IcIndicator };
//# sourceMappingURL=ic-indicator.js.map
